/**
 * CanvasToggle — a labelled checkbox for canvas chrome (the "Auto-arrange"
 * toggle): Duro's Checkbox. Extracted from SitemapCanvas so the native variant
 * can keep its own html.button rendering.
 */
import type { ReactNode } from "react";
import { Checkbox } from "@duro-app/ui";

export type CanvasToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
};

export function CanvasToggle({
  checked,
  onChange,
  children,
}: CanvasToggleProps) {
  return (
    <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)}>
      {children}
    </Checkbox>
  );
}
